<template>
  <div class="container">
    <v-fade-transition>
      <div
        v-show="
          [ROUTE_HOME, ROUTE_TOKEN_DETAILS].includes(route.name) &&
          latestTransactions.length
        "
        class="latest-transactions-carousel mb-4 mr-n2"
      >
        <Carousel
          dir="rtl"
          :options="{ currentPage: 0 }"
          snap-align="start"
          :autoplay="2000"
          :transition="1000"
          :breakpoints="{
            1680: { itemsToShow: 4 },
            1280: { itemsToShow: 3 },
            900: { itemsToShow: 3 },
            700: { itemsToShow: 2 },
            0: { itemsToShow: 1 },
          }"
          pause-autoplay-on-hover
        >
          <Slide
            v-for="transaction in latestTransactions"
            :key="transaction.hash"
          >
            <div class="d-flex ga-1">
              <token-image
                :cid="transaction.token.image_thumbnail"
                :width="20"
                :height="20"
              />
              <RouterLink
                :to="{
                  name: ROUTE_TOKEN_DETAILS,
                  params: { tokenName: transaction.token.symbol },
                }"
                >{{ transaction.token.symbol }}
              </RouterLink>
              <div
                v-if="
                  [TX_FUNCTIONS.sell, TX_FUNCTIONS.buy].includes(
                    transaction.tx_type
                  )
                "
                class="d-flex ga-1"
              >
                <div>of</div>
                <div
                  :class="`d-flex ga-1 text-${getTransactionColor(
                    transaction.tx_type
                  )}`"
                >
                  <span>AE</span>
                  <span>{{
                    Decimal.from(transaction.amount.ae).shorten()
                  }}</span>
                </div>
              </div>
              <span class="opacity-60">{{
                getTransactionType(transaction.tx_type)
              }}</span>
              <RouterLink
                :to="{
                  name: ROUTE_ACCOUNT_DETAILS,
                  params: { address: transaction.address },
                }"
                class="d-flex ga-1"
                ><span v-text="formatAddress(transaction.address)" />
                <AddressAvatar :address="transaction.address" :size="24" />
              </RouterLink>
            </div>
          </Slide>
        </Carousel>
      </div>
    </v-fade-transition>
  </div>
</template>

<script lang="ts" setup>
import "vue3-carousel/dist/carousel.css";
// https://ismail9k.github.io/vue3-carousel/examples.html
import { Carousel, Slide } from "vue3-carousel";

import { useRoute } from "vue-router";
import { onMounted } from "vue";

import {
  TX_FUNCTIONS,
  ROUTE_TOKEN_DETAILS,
  ROUTE_HOME,
} from "@/utils/constants";
import { formatAddress } from "@/utils";
import { useLatestTransactions } from "@/composables";
import { TransactionsService } from "@/api/generated";
import AddressAvatar from "@/components/Common/AddressAvatar.vue";
import TokenImage from "@/components/Tokens/TokenImage.vue";
import { Decimal } from "@/libs/decimal";

const route = useRoute();
const { latestTransactions } = useLatestTransactions();

onMounted(() => {
  TransactionsService.listTransactions({
    limit: 10,
    includes: "token",
  }).then((response: any) => {
    latestTransactions.value = response.items;
  });
});

function getTransactionType(type: string) {
  switch (type) {
    case TX_FUNCTIONS.sell:
      return "sold";
    case TX_FUNCTIONS.buy:
      return "bought";
    case TX_FUNCTIONS.create_community:
      return "created";
    default:
      return "";
  }
}

function getTransactionColor(type: string) {
  switch (type) {
    case TX_FUNCTIONS.buy:
      return "success";
    default:
      return "white";
  }
}
</script>

<style lang="scss" scoped>
@use "@/styles/variables" as *;

.latest-transactions-carousel {
  mask-image: linear-gradient(
    to right,
    transparent 0px,
    black 80px,
    black calc(100% - 80px),
    transparent 100%
  );
}
</style>
